// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WorkflowProvider } from './contexts/WorkflowContext';
import { CameraProvider } from './contexts/CameraContext'; // 新增导入
import { ReflectionProvider } from './contexts/ReflectionContext'; // 新增导入
import Layout from './components/Layout';
import ModelLoader from './pages/ModelLoader';
//import NodeEditorPage from './pages/NodeEditorPage';
import 'shepherd.js/dist/css/shepherd.css';
import './styles/shepherd-custom.css';
import './styles/global.css';
import './styles/MoldMaking.css';
// 在App.js中添加导入
import WireCopperElectroplating from './pages/WireCopperElectroplating';

const App = () => {
  return (
    <Router>
      <WorkflowProvider>
        <CameraProvider>
          <ReflectionProvider> {/* 新增包裹 */}
            <Routes>
              <Route path="/" element={<Layout />} />
              <Route path="/load-model" element={<ModelLoader />} />
            </Routes>
          </ReflectionProvider>
        </CameraProvider>
      </WorkflowProvider>
    </Router>
  );
};

export default App;